import { safetyWiseApi } from "utils/safetyWiseApi";

/**
 * Fetches paged leave records with filtering options
 * @param {string} organisationGuid - The organisation GUID
 * @param {object} params - Pagination and filtering parameters
 * @returns {Promise} - Promise resolving to API response
 */
export const getPagedLeaveRecords = (organisationGuid, params) => {
  // Use the new dedicated leaves/paged endpoint
  return safetyWiseApi.post(`${organisationGuid}/timesheet/leaves/paged`, params);
};

/**
 * Fetches paged timesheet records with filtering options, which now automatically excludes leave entries
 * @param {string} organisationGuid - The organisation GUID
 * @param {object} params - Pagination and filtering parameters
 * @returns {Promise} - Promise resolving to API response
 */
export const getPagedTimesheetRecords = (organisationGuid, params) => {
  // The API now automatically filters out leave records
  return safetyWiseApi.post(`${organisationGuid}/timesheet/paged`, params);
};

/**
 * Deletes a leave record
 * @param {string} organisationGuid - The organisation GUID
 * @param {string} leaveId - The leave ID to delete
 * @returns {Promise} - Promise resolving to API response
 */
export const deleteLeaveRecord = (organisationGuid, leaveId) => {
  return safetyWiseApi.del(`${organisationGuid}/timesheet/leaves/delete/${leaveId}`);
}; 